const angular = require('angular');
const app = angular.module('learn-directives');
const moment = require('moment');
/**
 * THIS FILE IS NO LONGER USED
 * Defines the users tracks status component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('adminUserAssigned', ['Application', 'Authorization', 'Assignments', 'Users', '$q', '$translate', function (Application, Authorization, Assignments, Users, $q, $translate) {
  return {
    restrict: 'E',
    scope: {
      suspended: '='
    },
    replace: true,
    template: require('../../templates/directives/admin-user-assigned.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.user = Authorization.getAuthToken().user;
      self.employee = {};
      self.assignments = [];
      self.predicate = 'completed';
      self.reverse = false;
      if (self.user.role !== 'admin') {
        Application.navigation.goTo('/explore');
      }
      self.translations;

      self.sortAction = function(type) {
        if (self.predicate === type) {
          self.reverse = !self.reverse;
          return;
        }
        self.reverse = false;
        self.predicate = type;
      };

      self.parseAndSet = function(items) {
        angular.forEach(items, function(assignment) {
          assignment.item = {
            title: self.translations['adminUserAssigned.item_archived'],
            link: '#/',
            type: null,
            archived: assignment.archived || false
          };
          if (assignment.article) {
            assignment.item.title = assignment.article.title;
            assignment.item.type = 'article';
            assignment.item.link = '#/host/articles/' + assignment.article._id;
          }
          if (assignment.media) {
            assignment.item.title = assignment.media.title;
            assignment.item.type = assignment.media.type;
            assignment.item.link = '#/host/' + assignment.media.type + 's/' + assignment.media._id;
          }
          if (assignment.quiz) {
            assignment.item.title = assignment.quiz.title;
            assignment.item.type = 'quiz';
            assignment.item.link = '#/view/quizzes/' + assignment.quiz._id;
          }
          if (assignment.track) {
            assignment.item.title = assignment.track.name;
            assignment.item.type = 'track';
            assignment.item.link = '#/host/track/' + assignment.track._id;
          }
          if (assignment.scorm) {
            assignment.item.title = assignment.scorm.title;
            assignment.item.type = 'scorm';
            assignment.item.link = '#/edit/scorm/' + assignment.scorm._id;
          }
          if (assignment.imported_content) {
            assignment.item.title = assignment.imported_content.title;
            assignment.item.type = 'imported-content';
            assignment.item.link = '#/edit/imported-content/' + assignment.imported_content._id;
          }
          if (assignment.assessment) {
            assignment.item.title = assignment.assessment.title;
            assignment.item.type = 'assessment';
            assignment.item.video_assessment = assignment.assessment.video_assessment;
            assignment.item.link = '#/edit/imported-content/' + assignment.assessment._id;
          }
        });
        return items.filter(function (assignment) {
          return assignment.item.archived === false; 
        });
      };

      self.initialize = function() {
        var routeParameters = Application.navigation.getRouteParameters();
        if (!routeParameters.id) {
          return;
        }
        var userPromise = $scope.suspended ? Users.suspended({_id: routeParameters.id, fields: '_id,first_name,last_name,full_name,email'}).$promise : Users.get({subresource: routeParameters.id}).$promise;
        var assignmentsPromise = Assignments.find({
          assignee: routeParameters.id,
          fields: 'assignee,completed,completed_date,assigner,article,media,track,quiz,scorm,imported_content,createdAt',
          'article-populate': 'title,type,archived',
          'media-populate': 'title,type,archived',
          'track-populate': 'name,type,archived',
          'scorm-populate': 'title,type,archived',
          'imported_content-populate': 'title,type,archived',
          'assessment-populate': 'title,type,video_assessment,archived',
          'quiz-populate': 'title,archived',
          'assigner-populate': 'first_name,last_name,full_name,email,archived',
          'assignee-populate': 'first_name,last_name,full_name,email,archived',
          'assigned_content.content_id-populate': 'title,name,description,banner_image,archived,type,image'
        }).$promise;

        $q.all([userPromise, assignmentsPromise]).then(function(results) {
          self.employee = results[0];
          if ($scope.suspended && self.employee[0]) {
            self.employee = self.employee[0];
          }
          results[1].forEach(function(item) {
            if (item.createdAt) {
              item.createdAt = new Date(parseInt(item._id.substring(0, 8), 16) * 1000);
            }
          });
          var assignments = results[1];
          self.translateData = {
            value : self.employee.first_name
          };
          self.assignments = self.parseAndSet(assignments);
        }).catch(function(error) {
          Application.messaging.addMessage({type: 'error', text: self.translations['adminUserAssigned.error_getting_assignments'], duration: 5});
        });
      };

      self.remindUser = function(id) {
        Assignments.remind({remindid: id}, null).$promise
        .then(function(success) {
          Application.messaging.addMessage({type: 'success', text: self.translations['adminUserAssigned.reminder_sent'], duration: 5});
        }).catch(function(error) {
          Application.messaging.addMessage({type: 'error', text: self.translations['adminUserAssigned.error_sending_reminder'], duration: 5});
        });
      };

      self.assignmentRemoval = {
        active: null,
        set: function(assignment) {
          this.active = assignment;
        },
        onDelete: function() {
          this.active = null;
          self.initialize();
        }
      };

      $translate([
        'adminUserAssigned.item_archived',
        'adminUserAssigned.error_getting_assignments',
        'adminUserAssigned.reminder_sent',
        'adminUserAssigned.error_sending_reminder',
      ]).then(function (translations) {

        self.translations = translations;
        self.initialize();

      })

    }],
    controllerAs: 'assigned'
  };
}]);


